var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5957 37.5309C33.4891 40.8651 31.5105 44.2922 28.1763 45.1856C24.8422 46.0789 21.4151 44.1003 20.5217 40.7661M4.28515 24.1945C3.47371 21.2816 4.31755 18.1324 6.47672 16.0155M25.3049 11.9602C25.9387 10.82 26.1474 9.44189 25.7831 8.08231C25.0386 5.30384 22.1827 3.65498 19.4043 4.39947C16.6258 5.14395 14.9769 7.99988 15.7214 10.7783C16.0857 12.1379 16.9556 13.227 18.0745 13.8976M42.3314 14.0001C41.5777 11.0718 39.2723 8.76636 36.3439 8.01265M36.4389 19.6778C35.6953 16.9025 33.71 14.5818 30.9198 13.2261C28.1297 11.8704 24.7632 11.5908 21.561 12.4488C18.3587 13.3069 15.583 15.2322 13.8445 17.8014C12.106 20.3705 11.5471 23.373 12.2908 26.1483C13.5211 30.74 13.2822 34.4033 12.5052 37.187C11.6197 40.3596 11.1769 41.9459 11.2965 42.2644C11.4334 42.6288 11.5324 42.7289 11.8954 42.8695C12.2126 42.9924 13.5455 42.6353 16.2112 41.921L40.9301 35.2976C43.5958 34.5833 44.9287 34.2262 45.142 33.9611C45.386 33.6578 45.4217 33.5217 45.358 33.1377C45.3023 32.802 44.1257 31.6496 41.7725 29.3448C39.7078 27.3226 37.6693 24.2696 36.4389 19.6778Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.2f6c7851.svg";
export { ForwardRef as ReactComponent };